export default "__VITE_ASSET__DVfkWWPi__"